import { LoadingComponent } from '@components/Loading';
import { connect } from '@lib/connect';
import { executeLogout } from '@redux/Auth/actions';
import React, { useEffect } from 'react';

/**
 * @author: Dumitrana Alinus <alin.designstudio@gmail.com>
 * @class: LogoutPage
 * @date:  06.09.2018
 * @time:  17:11
 * @scope:
 * @return {null}
 */
function LogoutPageSFC({ auth, executeLogout, redirect }) {
    useEffect(() => {
        if (auth) {
            executeLogout();
        }
    }, [auth]);

    if (auth) {
        return <LoadingComponent />;
    }

    // <Redirect> and props.history.push is not working, the homepage is not loading.
    window.location.href = redirect || '/';

    return null;
}

LogoutPageSFC.displayName = 'LogoutPage';

export const LogoutPage = connect(
    {
        auth: 'Auth.authenticated',
    },
    { executeLogout },
)(LogoutPageSFC);
